import {
  DOCTOR_UPDATE,
  DOCTOR_CREATE,
  DOCTOR_FETCH_ONE,
  DOCTOR_CLEAR,
  DOCTOR_GET_WALLET,
  DOCTOR_WALLET_HISTORY
} from '../actions/types';

const initialState = {
  detail: {},
  wallet: {},
  walletLists: []
};

export default function DoctorReducer(state = initialState, action = {
  type: undefined
}) {
  switch (action.type) {
    case DOCTOR_UPDATE:
    case DOCTOR_CREATE:
    case DOCTOR_FETCH_ONE:
    case DOCTOR_GET_WALLET:
      return { ...state, ...action.playload };
    case DOCTOR_WALLET_HISTORY:
      return {
        ...state,
        ...action?.playload,
        walletLists: action?.playload?.isAddMore ? [...state.walletLists, ...action.playload.data] : action?.playload.data
      };
    case DOCTOR_CLEAR:
      return { ...state, status: undefined, message: undefined };
    default:
      return { ...state };
  }
}
